<template>
  <v-container fluid grid-list-xl>
    <v-flex xs8 offset-xs2>
      <v-card>
        <v-container>
          <h1 class="display-1">JSON File Upload</h1>
          <!-- <v-textarea label="Paste JSON here" v-model="upload"></v-textarea> -->
          <!-- <input type="file"/> -->
          <v-btn :loading="loading" :disabled="loading" color="primary" class="white--text" @click="uploadItems()">
          Upload
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
        </v-container>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
// import ItemService from '@/services/ItemService'
import axios from 'axios'
export default {
  data () {
    return {
      loading: false,
      upload: null
    }
  },
  methods: {
    async uploadItems () {
      axios.get('https://api.diyblinds.com.au/items.txt')
        .then((result) => {
          console.log(result)
        })

      // for (const i in json) {
      //   const response = await ItemService.importItem(json[i])
      //   if (response.data.success) {
      //     console.log(response.data.item.name + ' imported')
      //   } else {
      //     console.error(response.data.message)
      //   }
      // }

      // this.loading = false
      // alert('Import complete.')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/import/Items.vue